import { Get, Post, Put } from '@/connection/helpers';
import { GlobalCurrency, ExchangeResponse, StripeLinkResponse, StripeResponse } from '@/types/integrations.types';

export function GetStripeLink(): Promise<StripeLinkResponse> {
  return Post({ path: '/v3/admin/channel/stripe', body: {} });
}

export function ContinueStripeLink(): Promise<StripeLinkResponse> {
  return Put({ path: '/v3/admin/channel/stripe', body: {} });
}

export function GetGlobalCurrencies(): Promise<GlobalCurrency[]> {
  return Get({ path: '/v3/admin/channel/global-currencies' });
}

export function GetExchangeRate(currencyCode: string): Promise<ExchangeResponse> {
  return Get({ path: `/v3/admin/channel/exchange-rate/${currencyCode}` });
}

export function SetStripeContact(email: string): Promise<{ email: string }> {
  return Post({ path: '/v3/admin/channel/stripe/contact', body: { email } });
}

export function GetStripeIntegration(): Promise<StripeResponse> {
  return Get({ path: '/v3/admin/channel/stripe' });
}
